import { render, staticRenderFns } from "./LandingReferencesWidget.vue?vue&type=template&id=44e3796b&"
import script from "./LandingReferencesWidget.vue?vue&type=script&lang=js&"
export * from "./LandingReferencesWidget.vue?vue&type=script&lang=js&"
import style0 from "./LandingReferencesWidget.vue?vue&type=style&index=0&id=44e3796b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports